import type { CalendarMode } from "../calendar/view.ts";

export interface DashboardCalendarActions {
  setMode(mode: CalendarMode, focus: string): void | Promise<void>;
  move(direction: -1 | 0 | 1, focus: string): void | Promise<void>;
  selectDate(date: string, focus: string): void | Promise<void>;
}

export function bindDashboardCalendar(root: ParentNode, actions: DashboardCalendarActions): void {
  root.querySelectorAll<HTMLElement>("[data-dashboard-calendar-mode]").forEach(button => button.addEventListener("click", () => {
    const mode = button.dataset.dashboardCalendarMode;
    if (mode === "day" || mode === "week" || mode === "month") void actions.setMode(mode, `[data-dashboard-calendar-mode="${mode}"]`);
  }));
  root.querySelectorAll<HTMLElement>("[data-dashboard-calendar-move]").forEach(button => button.addEventListener("click", () => {
    const value = button.dataset.dashboardCalendarMove;
    if (value === "-1" || value === "0" || value === "1") void actions.move(Number(value) as -1 | 0 | 1, `[data-dashboard-calendar-move="${value}"]`);
  }));
  root.querySelectorAll<HTMLElement>("[data-dashboard-calendar-day]").forEach(button => button.addEventListener("click", () => {
    const date = button.dataset.dashboardCalendarDay;
    if (date && /^\d{4}-\d{2}-\d{2}$/.test(date)) void actions.selectDate(date, `[data-dashboard-calendar-day="${date}"]`);
  }));
}
